<template>
  <div class="comments-rate">
    <div class="rate-box">
      <img v-for="i in 5" :key="i" v-lazy-load :data-src="getStarSrc(i)" alt="rate">
    </div>
  </div>
</template>

<script>
import rateHalf from '../assets/imgs/rate-half.webp';
import rateOne from '../assets/imgs/rate-one.webp';
import rateZero from '../assets/imgs/rate-zero.webp';

export default {
  name: 'CommentsRate',
  props: {
    rateLevel: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getStarSrc(index) {
      const full = Math.floor(this.rateLevel);
      const half = this.rateLevel - full >= 0.5;

      if (index <= full) {
        return rateOne;
      } if (index === full + 1 && half) {
        return rateHalf;
      }
      return rateZero;
    },
  },
};
</script>
<style lang="scss" scoped>
.comments-rate {
  .rate-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;

    img {
      width: 25px;
      height: 25px;
    }
  }
}

@media (max-width: 768px) {
  .comments-rate {
    .rate-box {
      gap: 4vw;

      img {
        width: 6.667vw;
        height: 6.667vw;
      }
    }
  }
}
</style>
